import { defineComponent as _defineComponent } from 'vue'
import { useUserNotes } from '@/store/useUserNotes';
import { onMounted, onUnmounted, ref, watch } from 'vue';
import { debounce } from 'lodash';


export default /*@__PURE__*/_defineComponent({
  __name: 'user-notes-panel',
  props: {
    uid: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const userNotes = useUserNotes();

const value = ref('');

const onKeyup = debounce(async () => await userNotes.setNotes(props.uid, value.value), 1000)

onMounted(async () => {value.value = await userNotes.getNotes(props.uid)});
onUnmounted(async () => {await userNotes.setNotes(props.uid, value.value)});
watch(() => props.uid, async (next, prev) => {
    const current = value.value;
    value.value = '';
    value.value = await userNotes.getNotes(next);
    await userNotes.setNotes(prev, current);
})


const __returned__ = { props, userNotes, value, onKeyup, get useUserNotes() { return useUserNotes }, onMounted, onUnmounted, ref, watch, get debounce() { return debounce } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})